var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-wrap"},[_c('div',{staticClass:"w-1/2 flex flex-wrap py-8 px-8"},[_c('mi-button',{attrs:{"small":"true","options":{
        color: _vm.passwordSaved ? 'success' : 'error',
        label: _vm.passwordButtonText,
        icon: _vm.passwordButtonIcon,
        round: true,
        outline: !_vm.isChangingPassword && !_vm.passwordSaved,
        flat: true,
      }},nativeOn:{"click":function($event){_vm.isChangingPassword = !_vm.isChangingPassword}}}),(_vm.isChangingPassword)?[_c('MiForm',{ref:"resetPasswordForm",staticClass:"w-full mt-24",attrs:{"options":{
          theme: 'light',
        },"fields":_vm.resetPasswordFields},on:{"fieldChanged":_vm.validatePassword}}),_c('p',{staticClass:"text-error-500 text-base"},[_vm._v(" "+_vm._s(_vm.passwordErrorMessage)+" ")]),_c('div',{staticClass:"flex w-full flex-wrap justify-between"},[_c('mi-button',{attrs:{"small":"true","options":{
            disabled: !_vm.passwordValid,
            color: 'success',
            label: 'Wachtwoord opslaan',
            icon: 'mdi-content-save',
            round: true,
            outline: !_vm.isChangingPassword,
            flat: true,
          }},nativeOn:{"click":function($event){return _vm.resetPassword()}}})],1)]:_vm._e()],2),_c('div',{staticClass:"flex w-full flex-wrap py-8 px-8"},[_c('mi-button',{attrs:{"small":"true","options":{
        color: 'error',
        label: 'MFA token verwijderen',
        icon: 'mdi-delete',
        round: true,
        flat: true,
      }},nativeOn:{"click":function($event){return _vm.deleteMfaToken()}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }